import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'
import { STORE_MAP } from '@/config/cache/cache-engine'

export default {
  getNotifications: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.NOTIFICATIONS].GET_NOTIFICATIONS,
  },
  patchNotificationsMarkAllRead: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.NOTIFICATIONS].PATCH_NOTIFICATIONS_MARK_ALL_READ,
  },
  patchNotificationsMarkReadStatus: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.NOTIFICATIONS].PATCH_NOTIFICATIONS_MARK_READ_STATUS,
  },
  getNotificationsUnreadCount: {
    useCache: true,
		cacheStorage: STORE_MAP.FULL,
    apiServiceMethodName: ModulesConfigMap[ModulesMap.NOTIFICATIONS].GET_NOTIFICATIONS_UNREAD_COUNT,
  },
  getNotification: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.NOTIFICATIONS].GET_NOTIFICATION,
  },
  patchNotification: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.NOTIFICATIONS].PATCH_NOTIFICATION,
  },
  getNotificationPreview: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.NOTIFICATIONS].GET_NOTIFICATION_PREVIEW,
  },
  getNotificationsSettings: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.NOTIFICATIONS].GET_NOTIFICATIONS_SETTINGS,
  },
  patchNotificationsSettings: {
    apiServiceMethodName: ModulesConfigMap[ModulesMap.NOTIFICATIONS].PATCH_NOTIFICATIONS_SETTINGS,
  },
}